import {
  buildOriginNlSourceTags,
  sendSyneriseForm,
  updateSyneriseClient,
} from "apps/visits/core/services/analytics/synerise";
import { vouchersDistributionCheckoutForm } from "apps/visits/core/services/analytics/synerise/forms/vouchers-distribution-checkout-form";
import { mapBooleanToEnabledDisabled } from "apps/visits/core/services/analytics/synerise/utils";
import { useCallback } from "react";
import { safeTrackEvent } from "../tracking/events";
import type { CustomerData } from "../types/customer-data";

export function useTrackCheckoutForm() {
  return useCallback((customerData?: CustomerData) => {
    if (!customerData) return;
    // REV-17: spójnie z pozostałymi zdarzeniami — synchroniczne budowanie formularza opakowane
    // w safeTrackEvent, by ewentualny błąd nie przerwał flow i trafił do diagnostyki event_missing.
    // (Sama wysyłka w sendSyneriseForm/updateSyneriseClient jest już odporna na poziomie usługi.)
    safeTrackEvent(
      () => {
        void sendSyneriseForm(
          vouchersDistributionCheckoutForm({
            firstname: customerData.firstName,
            lastname: customerData.lastName,
            email: customerData.email,
            phone: `${customerData.dialCode}${customerData.phone}`,
            newsletterAgreement: mapBooleanToEnabledDisabled(customerData.acceptNewsletter),
            phoneContactAgreement: mapBooleanToEnabledDisabled(customerData.acceptMarketingPhoneContact),
          }),
        ).then(() => {
          // PS-1676: origin/nlsource doczepiamy tylko gdy klient zapisał się do newslettera.
          if (customerData.acceptNewsletter) {
            updateSyneriseClient({ tags: buildOriginNlSourceTags("b2b", "vouchers_distribution") });
          }
        });
      },
      "synerise_checkout_form",
      "use-track-checkout-form",
    );
  }, []);
}
